export default __webpack_public_path__ + "images/24d2556c1826580b7816251fc94945ee-classical_music.jpg";